import { useEffect, useState } from "react";
import EnhancedTable from "../elementos/basicos/TablaPublicaciones";
import { fetchPublicacionConvocatoriaFilters, fetchActualizarPublicaciones } from '../../peticiones_API/PeticionesPublicaciones';
import { useLocation, useNavigate } from 'react-router-dom';
import Titulo from "../elementos/basicos/Titulo";
import styled from 'styled-components';
import dayjs from 'dayjs';
import { ConfirmacionEliminar } from '../elementos/eventos/avisos/VentanaEmergente';

const GestorBlogPublicaciones = (props) => {


    const location = useLocation();
    let params = new URLSearchParams(location.search);
    let paginaActual = parseInt(params.get("pagina"));
    let registrosPorPag = parseInt(params.get("registrosPorPag"));
    let busqueda = params.get("busqueda") || null;
    let editor = params.get("editor");
    //let categoria = params.get("categoria");
    let creador = params.get("creador");
    let fechaInicio = params.get("fechaInicio");
    let fechaFin = params.get("fechaFin");
    let ordenarColumna = params.get("ordenarColumna");
    let orden = params.get("orden");

    const [loading, setLoading] = useState(true);
    const urlPadre = window.location.pathname;
    const navigate = useNavigate();
    const [data, setData] = useState({
        meta: {},
        rows: []
    });

    const [fechaIncorrecta, setFechaIncorrecta] = useState(false);
    const [selected, setSelected] = useState([]);
    const [eliminarTodoCategorias, setEliminarTodoCategorias] = useState({ atributo: 'visible', valor: null });
    const [eliminarCatSelect, setEliminarCatSelect] = useState({ atributo: 'visible', valor: null }); 


    const confirmDialog = ConfirmacionEliminar();

    useEffect(() => {
        async function fechtActualizarFiltros() {
            console.log("Entra en el filtro");

            try {
                if (

                    eliminarTodoCategorias.valor == false ||
                    eliminarCatSelect.valor == false
                ) {
                    let mensaje = "";

                    if (eliminarTodoCategorias.valor === false || eliminarCatSelect.valor === false) {
                        mensaje = "eliminar";
                    }

                    const confirm = await confirmDialog.showAlert(mensaje, "categorias");

                    if (confirm) {
                        let categoriasActualizar = [];


                        if (eliminarTodoCategorias.valor === false) {
                            setEliminarTodoCategorias((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            const publicacionesResponse = await fetchPublicacionConvocatoriaFilters(
                                paginaActual,
                                registrosPorPag,
                                busqueda,
                                creador,
                                editor,
                                fechaInicio,
                                fechaFin,
                                ordenarColumna,
                                orden
                            );

                            publicacionesResponse.data.forEach((categoria) => {
                                categoriasActualizar.push(categoria.Id);
                            });

                            console.log("Entra en condición de desactivar todos");
                            await fetchActualizarPublicaciones(categoriasActualizar, eliminarTodoCategorias);
                            setSelected([]);
                        }


                        if (eliminarCatSelect.valor == false && selected.length !== 0) {
                            setEliminarCatSelect((prevState) => ({
                                ...prevState,
                                valor: null,
                            }));

                            categoriasActualizar = selected;
                            console.log("eliminarCatSelect", eliminarCatSelect);
                            await fetchActualizarPublicaciones(categoriasActualizar, eliminarCatSelect);
                            setSelected([]);
                        }


                        const publicacionesResponse = await fetchPublicacionConvocatoriaFilters(paginaActual, registrosPorPag, busqueda, ordenarColumna, orden);

                        const { data: publicacionesData, meta } = publicacionesResponse;

                        setData({
                            meta,
                            rows: formatData(publicacionesData),
                        });

                        navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                    } else {

                        setEliminarTodoCategorias((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                        setEliminarCatSelect((prevState) => ({
                            ...prevState,
                            valor: null,
                        }));
                    }
                }
            } catch (error) {
                console.error("Error al actualizar filtros:", error);
            }
        }



        if (
            eliminarTodoCategorias.valor !== null ||
            eliminarCatSelect.valor !== null
        ) {
            fechtActualizarFiltros();
        }
    }, [eliminarTodoCategorias, eliminarCatSelect, paginaActual, registrosPorPag, busqueda, ordenarColumna, orden, selected]);


    useEffect(() => {
        async function fechtPrincipal() {
            try {
                let publicacionesResponse;
                if (!paginaActual || !registrosPorPag) {
                    publicacionesResponse = await fetchPublicacionConvocatoriaFilters(paginaActual, registrosPorPag);
                    const { data: publicacionesData, meta } = publicacionesResponse;
                    paginaActual = meta.current_page;
                    registrosPorPag = meta.per_page;
                    navigate(`${urlPadre}?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`);
                    setData({
                        meta,
                        rows: formatData(publicacionesData)
                    });
                } else {
                    let urlParams = `?pagina=${paginaActual}&registrosPorPag=${registrosPorPag}`;
                    if (busqueda) urlParams += `&busqueda=${busqueda}`;
                    if (creador) urlParams += `&creador=${creador}`;
                    if (editor) urlParams += `&editor=${editor}`;
                    if (fechaInicio) urlParams += `&fechaInicio=${fechaInicio}`;
                    if (fechaFin) urlParams += `&fechaFin=${fechaFin}`;
                    if (ordenarColumna) urlParams += `&ordenarColumna=${ordenarColumna}`;
                    if (orden) urlParams += `&orden=${orden}`;
                    if (dayjs(fechaInicio, "DD/MM/YYYY").format("YYYY-MM-DD") > dayjs(fechaFin, "DD/MM/YYYY").format("YYYY-MM-DD")) {
                        setFechaIncorrecta(true);
                    } else {
                        setFechaIncorrecta(false);
                    }
                    navigate(`${urlPadre}${urlParams}`);
                    publicacionesResponse = await fetchPublicacionConvocatoriaFilters(
                        paginaActual, registrosPorPag, busqueda, creador, editor, fechaInicio, fechaFin, ordenarColumna, orden
                    );
                    const { data: publicacionesData, meta } = publicacionesResponse;
                    setData({
                        meta,
                        rows: formatData(publicacionesData)
                    });

                }
                setLoading(false);

            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        }

        fechtPrincipal();
    }, [paginaActual, registrosPorPag, creador, editor, fechaInicio, fechaFin, busqueda, ordenarColumna, orden, navigate, urlPadre]);

    const formatData = (data) => { console.log("data", data);
        return data.map((row) => {
            // console.log("row",  row.numSubcategorias);
            return {
                id: row.Id,
                titulo: row.titulo,
                url: row.url,
                fechaPublicacion: dayjs(row.fechaPublicacion,"YYYY-MM-DD").format("DD/MM/YYYY") ,
                creador: row.Creador.nombre + " " + row.Creador.apellidos + " ",
                editor: row.Editor!=null ? row.Editor.nombre + " " + row.Editor.apellidos + " " : "-",
                categoria: row.Categoria ? row.Categoria.categoria : "-",
                webDestino: row.webDestino ? row.webDestino : "-",
                editar: row.id,
            };
        });
    };

    const header = [
        {
            id: 'titulo',
            numeric: false,
            disablePadding: true,
            label: 'Título',
        },
        {
            id: 'fechaPublicacion',
            numeric: true,
            disablePadding: false,
            label: 'Fecha Publicación',
        },
        {
            id: 'creador',
            numeric: true,
            disablePadding: false,
            label: 'Creador',
        },
        {
            id: 'editor',
            numeric: true,
            disablePadding: false,
            label: 'Editor',
        },
        {
            id: 'categoria',
            numeric: true,
            disablePadding: true,
            label: 'Categoría',
        },
        {
            id: 'WebDestino',
            numeric: true,
            disablePadding: true,
            label: 'Web Destino',
        },
        {
            id: 'editar',
            numeric: true,
            disablePadding: false,
            label: '',
        }
    ];



    return (
        <>

            <CabeceraForm>
                <Titulo
                    texto="PUBLICACIONES"
                    tituloTabla="true"
                />
            </CabeceraForm>
            <EnhancedTable
                data={data.rows}
                header={header}
                meta={data.meta}
                selected={selected}
                setSelected={setSelected}
                eliminarTodoCategorias={eliminarTodoCategorias}
                setEliminarTodoCategorias={setEliminarTodoCategorias}
                eliminarCatSelect={eliminarCatSelect}
                setEliminarCatSelect={setEliminarCatSelect}
                isLoading={loading}
                fechaIncorrecta={fechaIncorrecta}
            />
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 5% 0% 1% 0%;
`
export default GestorBlogPublicaciones;